<template>
  <div class="company-device-item-bd ubv ub-f1">
    <div class="ub" style="margin-bottom: 24px">
      <div class="ub-f2" style="margin-right: 12px">
        <search-input width="100%" :placeholder="$t('company_device_item.gsxmmc')" v-model="formSearch.searchName" @fetch="onPageChange({ page: 1 })"></search-input>
      </div>
      <div class="ub-f3">
        <search-input width="100%" :placeholder="$t('Common.com_serial_no')" v-model="formSearch.search" @fetch="onPageChange({ page: 1 })"></search-input>
      </div>
    </div>
    <div class="table-bd ub-f1">
      <custom-table index height="100%" stripe tableCode="portal_organ_device" :data="deviceList" @column="setColumn"></custom-table>
    </div>
    <div class="table-page">
      <custom-pagination :total="totalRows" :page="formSearch.pageNum" :size="formSearch.pageSize" @change="onPageChange"></custom-pagination>
    </div>
  </div>
</template>

<script>
import apis from '@/utils/apis';

export default {
  name: 'company_distribution',
  props: {
    organ: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      dialogVisible: false,
      dialogModel: {},
      formSearch: {
        showSubsidiary: true,
        search: '',
        searchName: '',
        orderBy: '',
        orderType: '',
        bizId: '',
        bizType: '',
        parentId: '',
        isAss: 1,
        pageSize: 50,
        pageNum: 1,
        productCode: '',
        orgType: '',
        orgName: '',
        projectName: '',
        contractNo: '',
      },
      deviceList: [],
      totalRows: 0,
    };
  },
  watch: {
    organ: function () {
      this.formSearch = JSON.parse(this.resetFormSearch);
      this.deviceList = [];
      this.totalRows = 0;
      this.getOrganDevice();
    },
  },
  mounted: function () {
    this.resetFormSearch = JSON.stringify(this.formSearch);
    this.getOrganDevice();
    this.getFuncView();
  },
  methods: {
    // 组织设备
    getOrganDevice: function () {
      if (!this.organ.bizId) {
        return;
      }
      this.formSearch.bizId = this.organ.bizId;
      this.formSearch.bizType = this.organ.bizType;
      this.formSearch.parentId = this.organ.orgId;
      this.formSearch.showSubsidiary = this.showSubsidiary;
      this.$getJSON(apis.BizDevicePage, this.formSearch).then((res) => {
        this.deviceList = res.data.list;
        this.totalRows = res.data.total;
      });
    },
    // 分页变更
    onPageChange: function ({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getOrganDevice();
    },
  },
};
</script>

<style lang="scss">
</style>
